module.exports = __webpack_public_path__ + "img/banner.127b8db4.png";